import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-41">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-gradient-to-t from-stone-900/90 via-stone-900/70 to-transparent backdrop-blur-sm pointer-events-none" data-id="element-42">
          <div className="max-w-lg mx-auto pointer-events-auto" data-id="element-43">
            <a href="https://eficienciadigital.ca/cart/48274359353594:1" target="_blank" rel="noopener noreferrer" className="relative w-full group block" onClick={trackAddToCart} data-id="element-44">
              {/* Pulsing glow behind */}
              <div className="absolute -inset-1 bg-amber-500 rounded-full opacity-60 blur-lg animate-pulse group-hover:opacity-80 transition-opacity" data-id="element-45" />

              {/* Button */}
              <div className="relative flex items-center justify-center gap-3 bg-amber-600 hover:bg-amber-700 text-white font-bold text-lg rounded-full py-4 px-8 shadow-2xl shadow-amber-900/40 transition-colors" data-id="element-46">
                <span data-id="element-47">Quiero mi guía</span>
                <span className="text-amber-200 font-normal text-base line-through" data-id="element-48">
                  $25
                </span>
                <span className="text-white font-bold text-xl" data-id="element-49">$6.36</span>
                <ArrowRightIcon className="h-5 w-5 ml-1" data-id="element-50" />
              </div>
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}